import { Option } from 'types/types';
import Select from 'react-select';
import styled, { css } from 'styled-components';

type SelectProps = {
  options?: Option[];
  value?: any;
  onChange?: any;
  isDisabled?: boolean;
  styles?: any;
  placeholder?: string;
  disabled?: boolean;
  isMulti?: boolean;
  isClearable?: boolean;
  filterOption?: any;
  defaultValue?: any;
  error?: string | null;
  isOptionDisabled?(option: Option): boolean;
};

const EpdSelectComponent: React.FC<SelectProps> = ({
  options,
  value,
  onChange,
  isDisabled,
  styles,
  placeholder,
  isMulti,
  isClearable,
  filterOption,
  defaultValue,
  error = null,
  ...otherProps
}) => {
  const shouldShowPlaceholder = !isDisabled && !value;

  return (
    <StyledDiv $error={!!error}>
      <Select
        placeholder={shouldShowPlaceholder ? placeholder : ''}
        isDisabled={isDisabled}
        onChange={onChange}
        value={value}
        isMulti={isMulti}
        styles={styles}
        options={options}
        isClearable={isClearable}
        filterOption={filterOption}
        defaultValue={defaultValue}
        {...otherProps}
      />
      {error && <div style={{ color: 'red', fontSize: '0.875rem', marginTop: 4 }}>{error}</div>}
    </StyledDiv>
  );
};

const StyledDiv = styled.div<{ $error?: boolean }>`
  ${(props) =>
    props.$error &&
    css`
      > div:first-child {
        border: 1px solid ${props.theme.colors.statusLabelRedText}!important;
        & div {
          border-color: ${props.theme.colors.statusLabelRedText}!important;
        }
      }
    `}
`;

export default EpdSelectComponent;
